import { modifyPageLayoutComponents } from '../../PageLayout';
import {
  InstallationGroupItemsContainer,
  InstallationGroupItemsPageHeaderContainer,
  InstallationGroupItemsPageFooterContainer
} from './InstallationGroupItems';

export { InstallationGroupItems, InstallationGroupItemsPageHeader, InstallationGroupItemsPageFooter } from './InstallationGroupItems';
export { InstallationGroupItemsCard } from './InstallationGroupItemsCard';

export const InstallationGroupItemsLayoutComponents = modifyPageLayoutComponents({
  pageHeader: InstallationGroupItemsPageHeaderContainer,
  content: InstallationGroupItemsContainer,
  pageFooter: InstallationGroupItemsPageFooterContainer
});
